export default {
  logo: {
    id: 'product_page_noble_popup_logo_alt',
    defaultMessage: 'Noble Mobile',
  },
  popupTitle: {
    id: 'product_page_noble_popup_title',
    defaultMessage: 'Get $150 off this phone with your Noble Mobile code.',
  },
  popupBody: {
    id: 'product_page_noble_popup_body',
    defaultMessage:
      'Pair with a Noble Mobile plan and you save $150 on this phone.',
  },
  stepsTitle: {
    id: 'product_page_noble_popup_steps_title',
    defaultMessage: 'How to activate your savings',
  },
  step1: {
    id: 'product_page_noble_popup_step1',
    defaultMessage: 'Buy a plan from Noble Mobile',
  },
  step2: {
    id: 'product_page_noble_popup_step2',
    defaultMessage: 'Get the promo code in your confirmation email',
  },
  step3: {
    id: 'product_page_noble_popup_step3',
    defaultMessage: 'Use your code when purchasing a phone on Back Market',
  },
  closeButtonLabel: {
    id: 'product_page_noble_popup_close_button_label',
    defaultMessage: 'Close "Noble Mobile" popup',
  },
}
